import styled from 'styled-components';
import device from '../mediaQueries';

export const LetterImg = styled.img`
  width: auto;
  height: auto;
  position: absolute;
  top: 13px;
  left: 9px;
  ${({ header }) => (header ? 'filter: invert(100%);' : '')}
`;

export const LabelWrapper = styled.div`
  display: inline-block;
  color: black;
  height: 40px;
  width: 100%;
  position: relative;
  cursor: pointer;
  ${device.desktop`
    margin-top: ${({ header }) => (header ? '-5px' : '8px')};
    margin-left: -8px;
    height: 40px;
  `}
  width: 300px;
`;

export const EmphaticText = styled.span`
  position: absolute;
  left: 37px;
  top: 12px;
  color: white;
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  font-size: 15px;
  letter-spacing: 1px;
  text-transform: none;
  width: 100%;
  &&& {
    color: ${({ header }) => (header ? '#000' : '#fff')};
    cursor: pointer;
  }
  &&&:hover {
    color: #999;
  }
  ${device.desktop`
    font-size: 13px;
  `}
  & > span {
    font-weight: normal;
  }
`;
